var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunchplanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 103,
    viewBox: "0 0 59 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1324 71.4493C43.5973 60.1809 47.6369 46.1485 47.6369 34.2422C47.6369 8.7288 28.7144 1.5 28.7144 1.5C28.7144 1.5 9.79199 8.7288 9.79199 34.2422C9.79199 46.1485 13.8316 59.9683 18.2965 71.4493H39.1324Z",
    stroke: "#C4C4C4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7465 14.4693C37.2186 4.90179 28.9267 1.71262 28.9267 1.71262C28.9267 1.71262 20.6348 4.90179 15.1069 14.4693H42.7465Z",
    stroke: "#C4C4C4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5662 67.4097C56.5662 72.725 54.8653 77.8277 51.8888 81.6547C51.2509 74.4259 47.4239 68.2601 41.896 64.4331C43.5969 59.1178 45.2978 53.3773 46.3608 47.8494C52.5266 52.3142 56.5662 59.3304 56.5662 67.4097Z",
    stroke: "#C4C4C4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1702 64.6457C10.6423 68.4727 6.8153 74.8511 6.17746 81.8673C3.20089 77.8276 1.5 72.9376 1.5 67.6223C1.5 59.543 5.53962 52.3142 11.7054 48.062C12.7684 53.5899 14.2567 59.3304 16.1702 64.6457Z",
    stroke: "#C4C4C4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9269 43.1719C32.567 43.1719 35.5179 40.221 35.5179 36.581C35.5179 32.9409 32.567 29.99 28.9269 29.99C25.2868 29.99 22.3359 32.9409 22.3359 36.581C22.3359 40.221 25.2868 43.1719 28.9269 43.1719Z",
    stroke: "#C4C4C4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0059 81.2294V93.3483",
    stroke: "#C4C4C4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8477 81.2294V93.3483",
    stroke: "#C4C4C4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9268 88.2456V100.577",
    stroke: "#C4C4C4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchplanIcon);
export default __webpack_public_path__ + "static/media/launchplan-icon.4ae65306f0bc2796f14af04d38a1d407.svg";
export { ForwardRef as ReactComponent };